import {
  QUERY_GET_HIGHLIGHT_BY_ID,
  MUTATION_DELETE_HIGHLIGHT,
  MUTATION_UPSERT_HIGHLIGHT,
  MUTATION_VALIDATE_HIGHLIGHTED_OFFER_UPSERT,
  MUTATION_UNSCHEDULE_HIGHLIGHT,
  MUTATION_FINISH_ACTIVE_HIGHLIGHT,
  MUTATION_CLONE_HIGHLIGHTED_OFFER,
} from '../graphql'
import { apolloProvider } from '@/apollo-provider.js'
import { microservicesUrls } from '@/plugins/microservices/microservices'

export default {
  setHighlightKeyValue({ commit }, { payload, key }) {
    commit('SET_HIGHLIGHT_KEY_VALUE', { payload, key })
  },
  setHighlightObject({ commit }, payload) {
    commit('SET_HIGHLIGHT', payload)
  },
  setTagType({ commit }, payload) {
    commit('SET_TAG_TYPE', payload)
  },
  setUseHeaderImage({ commit }, payload) {
    commit('SET_USE_HEADER_IMAGE', payload)
  },
  async getHighlight({ commit }, variables) {
    const { highlightedOffer } = await apolloProvider.defaultClient
      .query({
        query: QUERY_GET_HIGHLIGHT_BY_ID,
        variables,
        fetchPolicy: 'no-cache',
        context: {
          uri: microservicesUrls['fedGateway'],
        },
      })
      .then(({ data: { highlightedOffer } }) => {
        return { highlightedOffer }
      })
    const highlight = {
      id: highlightedOffer.id,
      title: highlightedOffer.title,
      description: highlightedOffer.description,
      displayTitle: highlightedOffer.displayTitle,
      type: highlightedOffer.type,
      bannerImage: highlightedOffer.bannerImage,
      iconImage: highlightedOffer.iconImage,
      offersScheduleId: highlightedOffer.offersScheduleId,
      draft: highlightedOffer.draft,
      initialDate: highlightedOffer.initialDate,
      finalDate: highlightedOffer.finalDate,
      tag: {
        active: highlightedOffer.tag.active,
        image: highlightedOffer.tag.image,
      },
      products: highlightedOffer.products,
      productsGroups: highlightedOffer.productsGroups,
      units: highlightedOffer.units,
    }
    commit('SET_STATUS', highlightedOffer.status)
    commit('SET_HIGHLIGHT', highlight)
    commit('SET_OFFER_SCHEDULE', highlightedOffer.offersSchedule)
    if (highlight.tag.active) {
      commit('SET_TAG_TYPE', highlight.tag.image.length > 0 ? 'use-image' : 'default')
    }
  },

  mutateHighlight({ state, commit, dispatch }, { id, action }) {
    const actions = {
      unschedule: {
        mutation: MUTATION_UNSCHEDULE_HIGHLIGHT,
        variableName: 'unscheduleHighlightedOfferId',
      },
      delete: {
        mutation: MUTATION_DELETE_HIGHLIGHT,
        variableName: 'deleteHighlightedOfferId',
      },
      finish: {
        mutation: MUTATION_FINISH_ACTIVE_HIGHLIGHT,
        variableName: 'finishHighlightedOfferId',
      },
      clone: {
        mutation: MUTATION_CLONE_HIGHLIGHTED_OFFER,
        variableName: 'cloneHighlightedOfferId',
      },
    }
    const { mutation, variableName } = actions[action]
    return new Promise((resolve, reject) => {
      apolloProvider.defaultClient
        .mutate({
          mutation: mutation,
          variables: {
            [variableName]: id,
          },
          fetchPolicy: 'no-cache',
          context: {
            uri: microservicesUrls['fedGateway'],
          },
        })
        .then(
          (data) => {
            resolve(data)
          },
          (error) => {
            reject(error)
          }
        )
    })
  },
  upsertHighlight({ state, commit, dispatch }, variables) {
    return new Promise((resolve, reject) => {
      apolloProvider.defaultClient
        .mutate({
          mutation: MUTATION_UPSERT_HIGHLIGHT,
          variables,
          fetchPolicy: 'no-cache',
          context: {
            uri: microservicesUrls['fedGateway'],
          },
        })
        .then(
          ({ data: { upsertHighlightedOffer } }) => {
            resolve(upsertHighlightedOffer)
          },
          (error) => {
            reject(error)
          }
        )
    })
  },
  validateHighlightStep1({ state, commit, dispatch }, variables) {
    return new Promise((resolve, reject) => {
      apolloProvider.defaultClient
        .mutate({
          mutation: MUTATION_VALIDATE_HIGHLIGHTED_OFFER_UPSERT,
          variables,
          fetchPolicy: 'no-cache',
          context: {
            uri: microservicesUrls['fedGateway'],
          },
        })
        .then(
          ({ data: { validateHighlightedOfferUpsert } }) => {
            resolve(validateHighlightedOfferUpsert)
          },
          (error) => {
            reject(error)
          }
        )
    })
  },
  setHighlightProducts({ commit }, payload) {
    commit('SET_HIGHLIGHT_PRODUCTS', payload)
  },
  setHighlightDates({ commit }, payload) {
    commit('SET_HIGHLIGHT_DATES', payload)
  },
}
